module.exports = __webpack_public_path__ + "static/media/create_category.d87093b0.png";